import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { useHistory, useParams } from "react-router";
import { useApiEffect } from "nsitools-react";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { CharacteristicValuesDetailPage } from "../..";
import { CharacteristicValuesApi } from "../../../../api";
import { useGlobalData } from "../../../../contexts";

export interface ICharacteristicValuesItemPageProps {}

export const CharacteristicValuesItemPage: React.FunctionComponent<ICharacteristicValuesItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const api = useApiService(CharacteristicValuesApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageId), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.CharacteristicValues), route: ERoutes.characteristicValues },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsCharacteristicValues"
        onChange={(newTabId) => history.push(`${ERoutes.characteristicValues}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.characteristicValues} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CharacteristicValuesDetailPage characteristicValueId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
